import Rollbar from 'rollbar';
import { appConfig } from '../config/app-config';

const rollbarConfig = {
  accessToken: appConfig.rollbarKey,
  environment: import.meta.env.VITE_APP_ENVIRONMENT || 'local',
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: appConfig.rollbarKey != "",
  payload: {
    client: {
      javascript: {
        code_version: '1.0.0',
        source_map_enabled: true,
      },
    },
  },
  // Filter out known third-party errors (browser extensions, anti-fingerprinting, etc.)
  checkIgnore: function(_isUncaught: boolean, args: any[], payload: any) {
    const message = args[0];
    const messageStr = typeof message === 'string' ? message : (message?.message || '');

    // Ignore anti-fingerprinting and browser extension errors
    const ignorePatterns = [
      /^Script error\.?$/i, // Generic script errors with no useful info
      /Object Not Found Matching Id.*MethodName:/i,
      /antifingerprint/i,
      /chrome-extension:/i,
      /moz-extension:/i,
      /safari-extension:/i,
      /webkit-masked-url/i, // Safari privacy features masking URLs
      /\.tab\.customFillData/i, // Safari AutoFill/password manager
      /evaluating 't\.tab/i, // Safari extension errors
      /fields\.pageInfo/i, // Safari AutoFill/form-scanner extension (e.identifier fields.pageInfo)
    ];

    if (ignorePatterns.some(pattern => pattern.test(messageStr))) {
      return true;
    }

    // Ignore errors whose entire stack is masked by Safari's webkit-masked-url://
    // scheme. That masking is applied to browser-extension / injected content
    // scripts, so an error with NO real app frames did not originate in our code.
    // Real app errors always carry at least one radcliffesurveys.com frame.
    const traces = payload?.body?.trace_chain
      ? payload.body.trace_chain
      : payload?.body?.trace
        ? [payload.body.trace]
        : [];
    const frames = traces.flatMap((t: any) => t?.frames || []);
    if (frames.length > 0 && frames.every((f: any) => /webkit-masked-url/i.test(f?.filename || ''))) {
      return true;
    }

    return false;
  },
};

// Log configuration for debugging
console.log('Rollbar configuration:', {
  accessToken: rollbarConfig.accessToken ? `${rollbarConfig.accessToken.substring(0, 8)}...` : 'MISSING',
  environment: rollbarConfig.environment,
  enabled: rollbarConfig.enabled,
});

export const rollbar = new Rollbar(rollbarConfig);

// Export enabled flag for conditional rendering
export const isRollbarEnabled = rollbarConfig.enabled;

// Helper function to log to both console and Rollbar
export const logError = (message: string, error?: Error | unknown) => {
  console.error(message, error);
  if (rollbarConfig.enabled) {
    rollbar.error(message, error instanceof Error ? error : undefined);
  }
};
